<template>
  <span>
    <a-button :disabled="disabled || !siteId || loading" :loading="loading" icon="copy" @click="open">
      保存因子并同步
    </a-button>
    <select-site-checkbox-list-modal ref="sites" :sourceSiteId="siteId" @choseArchive="confirmSync" />
  </span>
</template>

<script>
import { postAction } from '@/api/manage'
import SelectSiteCheckboxListModal from '@/views/assets/SelectSiteCheckboxListModal.vue'

export default {
  components: { SelectSiteCheckboxListModal },
  props: {
    siteId: { type: Number, default: null },
    factors: { type: Array, required: true },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return { loading: false, snapshot: [] }
  },
  methods: {
    normalizeFactors() {
      if (!this.factors.length) throw new Error('请至少配置一个监测因子')
      const ids = new Set()
      const numericFields = ['factorId', 'lower', 'upper', 'decimals', 'unit', 'constantNum', 'monitorNum', 'sort']
      return this.factors.map((row, index) => {
        const config = { restriction: row.restriction == null ? '' : String(row.restriction).trim() }
        if (!/^[1-5]?$/.test(config.restriction)) throw new Error(`第${index + 1}行限制类型无效`)
        numericFields.forEach(field => {
          const value = row[field] == null ? '' : String(row[field]).trim()
          const number = value === '' ? null : Number(value)
          if (number !== null && (!Number.isFinite(number) ||
              (!['lower', 'upper'].includes(field) && (!Number.isInteger(number) || Math.abs(number) > 2147483647)))) {
            throw new Error(`第${index + 1}行存在无效数字`)
          }
          config[field] = number
        })
        if (!config.factorId || config.factorId < 0) throw new Error(`第${index + 1}行请选择监测因子`)
        if (ids.has(config.factorId)) throw new Error('监测因子不能重复')
        ids.add(config.factorId)
        if (['decimals', 'constantNum', 'monitorNum'].some(field => config[field] !== null && config[field] < 0) ||
            (config.unit !== null && config.unit <= 0)) throw new Error(`第${index + 1}行次数、精度或单位无效`)
        if (config.decimals > 20) throw new Error(`第${index + 1}行小数位需在0至20之间`)
        const lowerRequired = ['1', '2', '4'].includes(config.restriction)
        const upperRequired = ['1', '3', '5'].includes(config.restriction)
        if ((lowerRequired && config.lower === null) || (upperRequired && config.upper === null)) {
          throw new Error(`第${index + 1}行请填写有效的上下限`)
        }
        if (lowerRequired && upperRequired && config.lower > config.upper) throw new Error(`第${index + 1}行最小值不能大于最大值`)
        if (!lowerRequired) config.lower = null
        if (!upperRequired) config.upper = null
        return config
      })
    },
    open() {
      if (this.disabled || this.loading || !this.siteId) return
      try {
        this.snapshot = this.normalizeFactors()
        this.$refs.sites.add()
      } catch (error) {
        this.$message.warning(error.message)
      }
    },
    confirmSync(sites) {
      if (!sites.length || sites.length > 100) {
        this.$message.warning('请选择1至100个目标站点')
        return
      }
      const request = { sourceSiteId: this.siteId, targetSiteIds: sites.map(site => site.id), factors: this.snapshot }
      this.$confirm({
        title: '确认保存因子并覆盖目标站点配置？',
        content: `将保存当前${request.factors.length}个监测因子，并同步到${sites.length}个站点。当前站点及所选站点的原有监测因子配置将全部删除，再按当前填写内容重新保存。其他页签的修改不会保存。限制类型为空时，仍使用各站点自己的环境标准。`,
        okText: '保存并覆盖',
        cancelText: '取消',
        onOk: async () => {
          if (this.disabled || this.loading) return
          this.loading = true
          this.$emit('busy', true)
          try {
            const res = await postAction('/site/info/factor/sync', request)
            if (!res.success) throw new Error(res.message || '同步失败')
            this.$emit('synced', res.result.map(row => ({
              ...row, key: row.id, editable: true,
              lower_status: ['1', '2', '4'].includes(row.restriction),
              upper_status: ['1', '3', '5'].includes(row.restriction)
            })))
            if ((res.message || '').includes('缓存刷新失败')) this.$message.warning(res.message, 10)
            else this.$message.success(res.message)
          } catch (error) {
            this.$message.error(error.message || '同步请求失败，请重试')
            throw error
          } finally {
            this.loading = false
            this.$emit('busy', false)
          }
        }
      })
    }
  }
}
</script>
